import React from 'react';
import styled, { css } from 'styled-components';
import { StylableComponentProps } from '@cld/common-definitions';
import { asStyledComponent } from '@cld/component-enhancer';
import { INDICATOR_FIXED_DIMENSION_SIZE } from '../constants';
import { tabsTheme } from '../TabsTheme';
import { TabsProps } from './Tabs';

export interface IndicatorProps extends StylableComponentProps {
  indicatorPosition: number;
  indicatorSize: number;
  orientation: TabsProps['orientation'];
}

const Wrapper = styled.div<Pick<IndicatorProps, 'orientation'>>`
  bottom: 0;
  height: ${({ orientation }) => (orientation === 'vertical' ? '100%' : INDICATOR_FIXED_DIMENSION_SIZE)};
  left: 0;
  position: absolute;
  ${({ orientation }) => css`
    height: ${orientation === 'vertical' ? '100%' : INDICATOR_FIXED_DIMENSION_SIZE};
    width: ${orientation === 'vertical' ? INDICATOR_FIXED_DIMENSION_SIZE : '100%'};
    overflow-x: ${orientation === 'vertical' ? '' : 'hidden'};
  `};
`;

const verticalCss = css<Pick<IndicatorProps, 'indicatorPosition' | 'indicatorSize'>>`
  height: ${(props) => props.indicatorSize}px;
  width: 100%;
  left: 0;
  transform: translateY(${(props) => props.indicatorPosition}px);
  transition: height 150ms, transform 150ms;
`;

const horizontalCss = css<Pick<IndicatorProps, 'indicatorPosition' | 'indicatorSize'>>`
  height: 100%;
  width: ${(props) => props.indicatorSize}px;
  transform: translateX(${(props) => props.indicatorPosition}px);
  transition: transform 150ms, width 150ms;
  top: 0;
`;

const IndicatorLine = styled.div<IndicatorProps>`
  ${({ orientation }) => (orientation === 'vertical' ? verticalCss : horizontalCss)};
  background-color: ${tabsTheme.solid.indicator.color};
  position: absolute;
`;

export const Indicator = asStyledComponent(
  React.memo<IndicatorProps>(({ indicatorPosition, indicatorSize, orientation, className }) => (
    <Wrapper orientation={orientation} className={className}>
      <IndicatorLine indicatorSize={indicatorSize} indicatorPosition={indicatorPosition} orientation={orientation} />
    </Wrapper>
  ))
);
